import UserService from '../services/AdminsService';
import UserAuthenticateModel from '../models/UserAuthenticateModel';

export default {
  methods: {
    updateUserVuexStore() {
      UserService.profile().then(data => {
        const user = new UserAuthenticateModel(data);
        this.$store.commit('user', user);
      }).catch(() => {
        this.$router.push({ name: 'Page500' });
      });
    },
  },
};
